import { defineComponent as n, createBlock as r, openBlock as p, unref as s, mergeProps as c, withCtx as l, createElementVNode as e } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconReassuranceGoogle",
  __name: "IconReassuranceGoogle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const a = t;
    return (m, o) => (p(), r(s(i), c(a, { "view-box": "0 0 48 48" }), {
      default: l(() => [...o[0] || (o[0] = [
        e("g", { "clip-path": "url(#dsez1qa)" }, [
          e("path", { d: "M24 0a24 24 0 1 0 0 48 24 24 0 0 0 0-48m.29 38.88a14.88 14.88 0 1 1 0-29.76A14 14 0 0 1 34.12 13L30 17.11a8 8 0 0 0-5.66-2.2 9.11 9.11 0 0 0 0 18.21c5.63 0 7.7-3.94 8.09-6.28h-8.1v-5.55H38a12.92 12.92 0 0 1 .37 3.05c.03 8.5-5.6 14.54-14.08 14.54" })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "dsez1qa" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
